<mat-sidenav-container
  [ngClass]="{ 'overflow-hidden': isOpenSidenav }"
  hasBackdrop="false"
>
  <mat-sidenav
    [fixedTopGap]="heightHeader"
    [opened]="isOpenSidenav"
    class="w-full"
    fixedInViewport="true"
    mode="over"
    position="start"
  >
    <portal-ui-mega-menu></portal-ui-mega-menu>
  </mat-sidenav>

  <mat-sidenav-content>
    <section class="bg-banner-gradient">
      <portal-ui-header
        (burgerClick)="toggleSidenav()"
        [height]="heightHeader"
        [homeUrl]="HOME_PAGE_SME_URL"
        [isScroll]="config.hideHeroBanner ? true : isScroll"
        [openSidenav]="isOpenSidenav"
      ></portal-ui-header>

      <section
        #banner
        [class.!hidden]="config.hideHeroBanner"
        class="text-white px-5 py-24 max-w-screen-xl mx-auto"
      >
        <div>{{ config.page }}</div>
        <div class="font-bold text-5xl md:text-7xl">{{ config.title }}</div>
      </section>
    </section>

    <div
      [ngStyle]="{ 'margin-top': (config.hideHeroBanner ? heightHeader : 0) + 'px' }"
      class="w-full max-w-screen-xl mx-auto px-5 py-10"
    >
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
